import AddQuestionnaireRightContainer from "./AddQuestionnaireRightContainer";

export default AddQuestionnaireRightContainer;
